"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOneById = void 0;
const axios_1 = __importDefault(require("../shared/lib/axios"));
async function findOneById(id) {
    const { data } = await axios_1.default.post("/graphql", {
        query: `{
	powerTrain(power_train_id: "${id}") {
	    id
	    power_train_id
	    aplics_eikos_id
	    fuel_type
	    bbva_app_id
	    display_name
		name
		price
		colors {
			images360(limit:12) {
				url
			}
			color
			id
			slug
			exterior_thumbnail
			interiorColors {
				slug
				color
				url
				id
			}
		}
		trim {
			model {
			    slug
			    name
				year
				model_image
				trims {
					powerTrain {
						id
						power_train_id
						name
						price
					}
				}
			}
		}
	}
}
`,
    });
    return data.data.powerTrain;
}
exports.findOneById = findOneById;
